export enum SplitFlags {
  MOCK_FLAG = 'mock-flag', // for use in unit tests that require `SplitFlags` but that aren't coupled to a specific feature flag
  CH_TRAINING_PLANS = 'ch-training-plans',
  WB_ONBOARDING_UPDATE = 'wb-onboarding-update',
  CH_E3 = 'ch-exos-employer-experience',
}
